import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "dialog-content" }

import { ref, reactive, inject, Ref } from 'vue';
  import { IProgram } from '@/types/program';
  import _ from 'lodash';
  import { requestCollection } from '@/utils';
  import { ColorVariants } from '@/constants';
  import ApplyAction from './action.vue';
  import { useI18n } from 'vue-i18n';

  interface IProps {
    program: IProgram;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
    program: IProgram;
  }

  const { t } = useI18n();
  
  const refreshPageData = (inject('refreshPageData') || _.noop) as Function;
  const applyActionTeleportNode = inject<Ref<HTMLDivElement>>('applyActionTeleportNode');
  const showApplyAction = inject<() => void>('showApplyAction');
  const hideApplyAction = inject<() => void>('hideApplyAction');
  const dialog = reactive({
    applySuccess: false,
    joinWaitingListSuccess: false,
    error: false,
  });

  const errMessage = ref('');

  function closeDialog(dialogName?: string) {
    if (dialogName) {
      dialog[dialogName] = false;
    } else {
      _.forEach(dialog, (val, key) => {
        if (val) {
          dialog[key] = false;
        }
      });
    }
    hideApplyAction && hideApplyAction();
  }

  function showDialog(dialogName: string) {
    closeDialog();
    dialog[dialogName] = true;
    showApplyAction && showApplyAction();
  }

  const start = () => {
    return apply();
  };

  async function apply() {
    try {
      const result = await requestCollection(props.program);
      if (result) {
        await refreshPageData();
        if (result.status === 'success') {
          showDialog('applySuccess');
        }
        if (result.status === 'wait_list') {
          showDialog('joinWaitingListSuccess');
        }
      }
    } catch (e) {
      const errorMsg = _.get(e, 'message');
      errMessage.value = errorMsg;
      showDialog('error');
    }
  }

  expose({
    start
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, {
    to: _unref(applyActionTeleportNode) ? _unref(applyActionTeleportNode) : 'body'
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(applyActionTeleportNode) ? ApplyAction : 'AppDialog'), _mergeProps({
      visible: _unref(dialog).applySuccess,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).applySuccess) = $event))
    }, _unref(applyActionTeleportNode) ? {} : { class: 'dialog-on-going-program' }, {
      btns: [
        { text: _unref(t)('on_going_program_apply_success_button'), style: _unref(ColorVariants).dark, click: () => closeDialog() }
      ]
    }), {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('on_going_program_apply_success_content')), 1)
      ]),
      _: 1
    }, 16, ["visible", "btns"])),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(applyActionTeleportNode) ? ApplyAction : 'AppDialog'), _mergeProps({
      visible: _unref(dialog).joinWaitingListSuccess,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialog).joinWaitingListSuccess) = $event))
    }, _unref(applyActionTeleportNode) ? {} : { class: 'dialog-on-going-program' }, {
      content: _unref(t)('on_going_program_join_waiting_list_success_content'),
      btns: [
        { text: _unref(t)('on_going_program_join_waiting_list_success_button'), style: _unref(ColorVariants).dark, click: () => closeDialog() }
      ]
    }), null, 16, ["visible", "content", "btns"])),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(applyActionTeleportNode) ? ApplyAction : 'AppDialog'), _mergeProps({
      visible: _unref(dialog).error,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).error) = $event)),
      content: errMessage.value
    }, _unref(applyActionTeleportNode) ? {} : { class: 'dialog-on-going-program' }, {
      btns: [
        { text: _unref(t)('on_going_program_dialog_error_button'), style: _unref(ColorVariants).dark, click: () => closeDialog() },
      ]
    }), null, 16, ["visible", "content", "btns"]))
  ], 8, ["to"]))
}
}

})